/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const LOGIN_TOOLTIP_COOKIE_NAME = 'loginTooltipShowed';
export const LOGIN_TOOLTIP_COOKIE_VALUE = 'true';
export const LOGIN_TOOLTIP_AFTER_ONE_TAP_ONLY =
  'login_tooltip_after_one_tap_only';
